export const LEGACY_ROUTING_FLAG = 'legacy';
export const LEGACY_ROUTING_COOKIE = 'hp_legacy';
export const ROUTING_COOKIE_MAX_AGE_SECONDS = 31536000;
